import { createSlice } from "@reduxjs/toolkit";

export const initialState = 
{
  sortField: null,
  sortDesc: true,
  isEditingTreatment: false,
  isEditingActivity: false,
  rootServiceUrl: "",
  viewRootServiceUrl: "",
  summaryViewRootServiceUrl: "",
  nifcToken: "",
  config: null
}

export const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    setIsEditingTreatment: (state, action) => {
      state.isEditingTreatment = action.payload;
    },
    setRootServiceUrl: (state, action) => {
      state.rootServiceUrl = action.payload;
    },
    setViewRootServiceUrl: (state, action) => {
      state.viewRootServiceUrl = action.payload;
    },
    setSummaryViewRootServiceUrl: (state, action) => {
      state.summaryViewRootServiceUrl = action.payload;
    },
    setIsEditingActivity: (state, action) => {
      state.isEditingActivity = action.payload;
    },
    setConfig: (state, action) => {
      state.config = action.payload;
    },
    setNifcToken: (state, action) => {
      state.nifcToken = action.payload;
    },
    fetchConfig: (state) => {
      return state.config;
    }
  }
});

export const {setIsEditingActivity, setIsEditingTreatment, setConfig, fetchConfig, setRootServiceUrl, setViewRootServiceUrl, setSummaryViewRootServiceUrl, setNifcToken } = configurationSlice.actions;

export default configurationSlice.reducer;